<template>
  <div class="px-0">
    <!-- Sub Navigation -->
    <sub-navigation />
    <!-- Sub Navigation -->
    <div class="container-fluid">
      <b-row class="pt-3 min-h-80 px-5 bg-section1">
        <b-col
          md="5"
          sm="12"
          class="d-flex justify-content-center"
        >
          <div
            class="align-self-center pt-3"
          >
            <div
              class="align-self-center"
            >
              <div class="pr-5">
                <img
                  id="company-logo"
                  data-aos="fade-right"
                  data-aos-delay="350"
                  class="img-fluid"
                  :src="require('@/assets/svg/maxlogo.png')"
                  alt="Company Logo"
                >
              </div>
              <h2
                data-aos="fade-right"
                data-aos-delay="350"
                class="font-large-2 font-weight-bolder mt-3"
              >
                SMS Broadcast
              </h2>
              <p
                data-aos="fade-up"
                data-aos-delay="350"
                class="font-medium-4 line-height-condensed"
              >
                Product Catalogue
              </p>
            </div>
          </div>
        </b-col>
        <b-col
          md="7"
          sm="12"
          class="d-flex justify-content-center"
        >
          <div
            data-aos="fade-left"
            data-aos-delay="350"
            class="text-center align-self-center px-2"
          >
            <img
              id="company-logo"
              class="img-fluid"
              :src="require('@/assets/svg/paternioh.svg')"
              alt="Company Logo"
            >
          </div>
        </b-col>
      </b-row>

      <!-- section 2 -->
      <b-row class="pt-3 px-5 bg-section2a">
        <b-col
          md="4"
          sm="12"
          class="d-flex flex-column justify-content-center"
        >
          <div class="px-0">
            <img
              id="company-logo"
              data-aos="fade-right"
              class="img-fluid w-50"
              :src="require('@/assets/svg/maxlogo.png')"
              alt="Company Logo"
            >
          </div>
          <h2
            data-aos="fade-right"
            class="font-large-2 font-weight-bolder mt-3 bg-text"
          >
            Media Channel -
            SMS Broadcast.
          </h2>
          <p
            data-aos="fade-up"
            class="font-medium-4 line-height-condensed"
          >
            An official IOH Telco SMS Broadcast, delivering
            a variety of digital product and data product promotions
            and contents that based on user unique interest and
            behavior to persuade IOH subscribers to purchase the
            promoted data packs, special branding messages or
            VAS content subscription products including the OTT.
          </p>
          <label class="px-2 py-50 bg-text2 rounded font-medium-4 font-weight-bolder text-white w-fit">
            Custom Content & Sender
          </label>
        </b-col>
        <b-col
          md="4"
          sm="12"
        >
          <div
            class="align-self-center"
          >
            <div class="w-100 text-center mt-1 mb-1">
              <img
                id="company-logo"
                data-aos="zoom-in"
                class="img-fluid"
                :src="require('@/assets/svg/hp-sms.svg')"
                alt="Company Logo"
              >
            </div>
          </div>
        </b-col>
        <b-col
          md="4"
          sm="12"
        >
          <div
            data-aos="fade-left"
            class="w-100 text-center mt-1 mb-1"
          >
            <img
              id="company-logo"
              class="img-fluid"
              :src="require('@/assets/svg/list-sms.svg')"
              alt="Company Logo"
            >
          </div>
        </b-col>
      </b-row>

      <footers />
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  //   BNav,
  // BNavItem,
  //   BNavbarBrand,
  //   BNavbarToggle,
  // BNavbar,
  // BNavbarNav,

//   BCollapse,
} from 'bootstrap-vue'

import SubNavigation from '@/views/landing/SubNavigation.vue'
import Footers from '@/views/landing/Footer.vue'

export default {
  name: 'YourMagnificentVueComponent',
  components: {
    BRow,
    BCol,
    Footers,
    // BNav,
    // BNavbar,
    // BNavbarNav,
    // BNavItem,
    SubNavigation,
  },
  data() {
    return {
      desc: ' ',
    }
  },
  mounted() {},
  methods: {
    goTo() {
      this.$router.push({ name: 'home' })
    },
  },
}
</script>
<style scoped lang="scss">
.bg-text {
    background-image: linear-gradient(100.76deg, #F17030 -16.82%, #E92751 23.38%, #CA2386 43.15%, #76529E 68.2%, #52B2B1 107.74%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.bg-text2 {
    background-image: linear-gradient(180deg, #C6168D 0%, #ED1C24 49.48%, #EC008C 100%);
}
.w-fit {
  width: fit-content;
}
.bg-section2a{
    background-image: url("../../assets/svg/bg-section2a.svg");
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
}
.pt-15 {
    padding-top: .1rem;
}
.min-h-1 {
    min-height: 120vh;
}
.min-h-2 {
    min-height: 100vh;
}
.min-h-70 {
    min-height: 70vh;
}
.min-h-80 {
    min-height: 80vh;
}
.min-h-90 {
    min-height: 90vh;
}
.min-h-17{
  min-height: 17rem;
}
.font-s-1 {
    font-size: 1rem;
}
</style>
